import { sendLoggingInformation } from "../sendLoggingInformation";
import { EnumActionNameLevel1, EnumActionNameLevel2, EnumActionNameLevel3, EnumGeneratedBy, EnumUxTypes} from "../types/LoggingTypes";
import { updateActionHistory } from "./updateActionHistory";
import { updateWidgetHistory } from "./updateWidgetHistory";


const logOrderProductsView = () => {
      updateActionHistory(EnumActionNameLevel1.ORDER, EnumActionNameLevel2.PRODUCTS, EnumActionNameLevel3.VIEW);
      updateWidgetHistory('')
      sendLoggingInformation({uxType: EnumUxTypes.SCREEN, actionGeneratedBy: EnumGeneratedBy.USER});
  }

const logOrderProductsClickAddCart = () => {
    updateActionHistory(EnumActionNameLevel1.ORDER, EnumActionNameLevel2.PRODUCTS, EnumActionNameLevel3.CLICK_ADD_TO_CART);
    updateWidgetHistory('')
    sendLoggingInformation({uxType: EnumUxTypes.BUTTON, actionGeneratedBy: EnumGeneratedBy.USER});
}

const logBoostListingBundle = (modelId : number)=>{
    updateActionHistory(EnumActionNameLevel1.BOOST, EnumActionNameLevel2.LISTING, EnumActionNameLevel3.BUNDLE);
    updateWidgetHistory('')
    sendLoggingInformation({uxType: EnumUxTypes.BUTTON, actionGeneratedBy: EnumGeneratedBy.USER, action_reference_entity: 'post', action_reference_id: modelId});
}

const logPermissionLocationAllow = ()=>{
    updateActionHistory(EnumActionNameLevel1.PERMISSION, EnumActionNameLevel2.LOCATION, EnumActionNameLevel3.ALLOW);
    updateWidgetHistory('');
    sendLoggingInformation({actionGeneratedBy: EnumGeneratedBy.USER, uxType: EnumUxTypes.NA});
}

const logPermissionLocationDeny = ()=>{
    updateActionHistory(EnumActionNameLevel1.PERMISSION, EnumActionNameLevel2.LOCATION, EnumActionNameLevel3.DENY);
    updateWidgetHistory('');
    sendLoggingInformation({actionGeneratedBy: EnumGeneratedBy.USER, uxType: EnumUxTypes.NA});
}

export {logPermissionLocationDeny, logPermissionLocationAllow, logOrderProductsView, logOrderProductsClickAddCart, logBoostListingBundle}